import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_NONE} from 'shared/lib/filterHelper';
import {IPortMonitorListItem} from 'features/port/model/PortMonitor/IPortMonitor';

import PortIncidentsExportFormHandler from './PortIncidentsExportFormHandler';

interface IPortIncidentsExportModalProps {
    monitors: IPortMonitorListItem[],
    open: boolean,
    handleClose: () => void,
}

const PortIncidentsExportModal: React.FC<IPortIncidentsExportModalProps> = ({monitors, open, handleClose}) => (
    <FiltersModal
        header={t`Экспорт инцидентов портов`}
        open={open}
        handleClose={handleClose}
        keepParams={FILTERS_KEPT_NONE}
        withReset={false}
    >
        <PortIncidentsExportFormHandler monitors={monitors} handleClose={handleClose}/>
    </FiltersModal>
);

export default PortIncidentsExportModal;
